// extracted by mini-css-extract-plugin
export default {"avatarSelector":"AvatarSelectNew_avatarSelector__1L4l0","avatar":"AvatarSelectNew_avatar__quXHh","edit":"AvatarSelectNew_edit__2pxvU","fileInput":"AvatarSelectNew_fileInput__WsbHk"};